import delayCycle from "../../assets/delay-cycle.png";
import stockFlow from "../../assets/stock-flow.png";
import shopFloor from "../../assets/shop-floor.png";
import costVariance from "../../assets/cost-variance.png";
import deptSilos from "../../assets/dept-silos.png";
import annualLoss from "../../assets/annual-loss.png";
import erpFlow from "../../assets/erp-sync-flow.png";
import { Link } from "react-router-dom";

function Blog() {
  return (
    <div style={styles.container}>
      <h1 style={styles.mainHeading}>
        {/* Why Production Delays Keep Happening in Small Manufacturing Units */}
      </h1>

      <h2 style={styles.subHeading}>
        Facing frequent Production delays in your Manufacturing Unit?
      </h2>

      <p style={styles.paragraph}>
        Learn the real causes and how Manufacturing ERP software improves
        planning, inventory control, and on-time delivery.
      </p>

      <p style={styles.paragraph}>
        If you run a small or mid-sized manufacturing unit, you've likely faced
        raw materials arriving late, sudden schedule changes, missed deadlines,
        customer complaints, and shrinking margins from penalties.Production
        delays stem from systemic failures like lack of real-time control in
        most small factories.
      </p>

      <h4 style={styles.sectionTitle}>
        Here's a quick visual of the delay cycle:
      </h4>
      <img src={delayCycle} alt="Delay Cycle" style={styles.image} />

      <h3 style={styles.sectionHeading}>1. No Real-Time Production Planning</h3>
      <p style={styles.paragraph}>
        SMEs rely on Excel, manual registers, WhatsApp, or verbal instructions,
        causing wrong allocations, capacity blind spots, overlaps, and missed
        timelines.
      </p>
      <h3 style={styles.sectionHeading}>Manual vs ERP Planning</h3>
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>Method</th>
            <th style={styles.th}>Issues</th>
            <th style={styles.th}>ERP Fix</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={styles.td}>Manual (Excel)</td>
            <td style={styles.td}>No real-time updates</td>
            <td style={styles.td}>Capacity scheduling</td>
          </tr>
          <tr>
            <td style={styles.td}>Verbal/WhatsApp</td>
            <td style={styles.td}>Miscommunication</td>
            <td style={styles.td}>MRP & auto orders</td>
          </tr>
          <tr>
            <td style={styles.td}>Impact</td>
            <td style={styles.td}>20-30% delays </td>
            <td style={styles.td}>What/When/How much visible</td>
          </tr>
        </tbody>
      </table>
      <p style={styles.paragraph}>
        <strong>ERP Benefits:</strong> Real-time planning tells you exactly
        what, when, how much to produce, and required materials.
      </p>
      <h3 style={styles.sectionHeading}>2. Raw Material Shortages</h3>
      <p style={styles.paragraph}>
        Production starts without enough stock due to no live visibility,
        unaligned purchases, missing alerts, and siloed departments.
      </p>
      <h3 style={styles.sectionHeading}>Stock Flow Breakdown</h3>
      <img src={stockFlow} alt="Stock Flow" style={styles.image} />
      <p style={styles.paragraph}>
        <strong>ERP Benefits:</strong>Integrates inventory, purchase,
        production—auto-generates requests, alerts, and order-aligned planning.
        Result: Zero surprises.
      </p>
      <h3 style={styles.sectionHeading}>3. Poor Shop Floor Monitoring</h3>
      <p style={styles.paragraph}>
        Manual updates hide lags, downtime, rework, and wastage—no real-time
        tracking.
      </p>
      <h3 style={styles.sectionHeading}>Shop Floor Dashboard Example</h3>
      <img src={shopFloor} alt="Shop Floor" style={styles.image} />
      <p style={styles.paragraph}>
        <strong>ERP Benefits:</strong>Work orders, job cards, live status,
        rejection tracking, utilization reports—all accessible remotely.
      </p>
      <h3 style={styles.sectionHeading}>4. Lack of Cost Visibility</h3>
      <p style={styles.paragraph}>
        Unknown batch costs, wastage, labor efficiency, and idle time obscure
        financial hits from delays.
      </p>
      <h3 style={styles.sectionHeading}>Cost Variance Chart</h3>
      <img src={costVariance} alt="Cost Variance" style={styles.image} />
      <p style={styles.paragraph}>
        <strong>ERP Benefits:</strong>Calculates actual vs. planned, per-unit
        costs, variances, and order margins for data-driven decisions.
      </p>
      <h3 style={styles.sectionHeading}>
        5. Communication Gap Between Departments
      </h3>
      <p style={styles.paragraph}>
        Sales overpromises, production uninformed, purchase unaware, accounts
        slow—pure chaos.
      </p>
      <h3 style={styles.sectionHeading}>Dept Silos vs ERP Hub</h3>
      <img src={deptSilos} alt="Department Silos" style={styles.image} />

      {/* ERP Benefits */}
      <p style={styles.paragraph}>
        <strong>ERP Benefits:</strong> Centralizes all modules — everyone on one
        system.
      </p>

      {/* Financial Impact */}
      <h3 style={styles.sectionHeading}>
        Financial Impact of Production Delays
      </h3>

      <p style={styles.paragraph}>For a ₹50 Lakhs/month unit:</p>

      <p style={styles.highlightBox}>
        10% loss = ₹5 Lakhs/month
        <br />
        (₹60 Lakhs/year) — more than ERP costs.
      </p>

      {/* Annual Loss Pie Image */}
      <h4 style={styles.sectionTitle}>Visual: Annual Loss Pie</h4>

      <img src={annualLoss} alt="Annual Loss Pie Chart" style={styles.image} />

      <h3 style={styles.sectionHeading}>How Manufacturing ERP Prevents Delays</h3>
      <p style={styles.paragraph}>
        ✔ MRP, Capacity Planning, Batch Tracking, Work Orders, Real-Time Inventory,
         Vendor Mgmt, Cost Reports—all synced.
      </p>
      <img src={erpFlow} alt="ERP Flow" style={styles.image} />

      <h3 style={styles.sectionHeading}>Signs Your Factory Needs ERP</h3>
      <ul style={styles.list}>
        <li>Missed deliveries</li>
        <li>Inventory mismatches</li>
        <li>Overtime spikes</li>
        <li>Visibility gaps</li>
        <li>Rising complaints</li>
        <li>Shrinking margins</li>
      </ul>

      <h2 style={styles.ctaHeading}>🚀 Ready to Stop Delays?</h2>
<div style={{ textAlign: "center" }}>
  <Link to="/contact" style={styles.button}>
    Request Access One ERP – Manufacturing Edition Demo
  </Link>
</div>

    </div>
  );
}

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "40px 20px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.8",
    color: "#333",
  },
  mainHeading: {
    fontSize: "30px",
    marginBottom: "60px",
    fontWeight: "bold",
  },
  subHeading: {
    fontSize: "27px",
    marginBottom: "15px",
    color: "#1e3a8a",
    fontWeight: "bold",
  },
  paragraph: {
    marginBottom: "10px",
    fontSize: "16px",
    textAlign: "left"
  },
  sectionHeading: {
    marginTop: "20px",
    marginBottom: "15px",
    fontSize: "20px",
    color: "#0f172a",
  },
  sectionTitle: {
    marginTop: "20px",
    marginBottom: "10px",
  },
  image: {
    display: "block",
    maxWidth: "400px",
    width: "100%",
    margin: "20px auto",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
  },
  th: {
    border: "1px solid #ddd",
    padding: "10px",
    backgroundColor: "#f3f4f6",
  },
  td: {
    border: "1px solid #ddd",
    padding: "10px",
  },
  list: {
    marginTop: "10px",
    paddingLeft: "20px",
  },
  ctaHeading: {
    marginTop: "40px",
    fontSize: "24px",
  },
  button: {
  display: "block",
  margin: "20px auto",   // 👈 this centers it
  padding: "14px 28px",
  backgroundColor: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: "bold",
  transition: "0.3s",
},
//   button: {
//     marginTop: "20px",
//     padding: "14px 28px",
//     backgroundColor: "#2563eb",
//     color: "#fff",
//     border: "none",
//     borderRadius: "8px",
//     cursor: "pointer",
//     fontSize: "16px",
//     fontWeight: "bold",
//     transition: "0.3s",
//   },
  highlightBox: {
    backgroundColor: "#fef3c7",
    padding: "15px",
    borderLeft: "5px solid #f59e0b",
    fontWeight: "bold",
    marginTop: "10px",
    borderRadius: "6px",
  },
};

export default Blog;
